// extracted by mini-css-extract-plugin
export default {"root":"_273xK","avatar":"iIF4g"};